import React, { useCallback, useEffect, useState } from 'react'
import { ancemntSaveData, ancemntGetData, initAncemntState } from '../../redux/slices/announcementSlice'
import { getAnnouncementTypesPath, deleteAnnouncementTypePath } from '../../services/config'
import { useDispatch, useSelector } from 'react-redux'
import { RiDeleteBinLine } from "react-icons/ri";
import { PiPencilSimpleLineBold } from "react-icons/pi";

const AnnouncementType = ({ announcementType, handleAnnouncementTitleId, setAnnouncementType, setAnnouncementTypeIcon, handleAnnTypeClicked, setIsEditAnnType, setCreateAnnType, handleEditAnnouncementType, isEditAnnTypeSuccess, setIsEditAnnTypeSuccess }) => {

    const user = JSON.parse(localStorage.getItem("user_data")) || {}

    const dispatch = useDispatch()
    const annStore = useSelector((state) => state.announce)

    const [annTypeLict, setAnnTypeLict] = useState([])

    const getAnnTypeList = () => {
        let path = `${getAnnouncementTypesPath}${user.user_id}`
        dispatch(ancemntGetData(path))
    }

    useEffect(() => {
        getAnnTypeList()
    }, [])

    useEffect(() => {
        if (annStore.ancemntGetSuccess) {
            setAnnTypeLict(annStore.ancemntGetData)
            dispatch(initAncemntState())
        }
        if (annStore.ancemntSuccess) {
            getAnnTypeList()
            dispatch(initAncemntState())
        }

        if (isEditAnnTypeSuccess == true) {
            setAnnTypeLict([])
            getAnnTypeList()
            setIsEditAnnTypeSuccess(false)
        }
    }, [annStore, isEditAnnTypeSuccess])

    const deleteAnnouncement = (id) => {
        const formData = {
            path: deleteAnnouncementTypePath,
            data: {
                userId: user.user_id,
                announceId: id
            }
        }
        dispatch(ancemntSaveData(formData))
    }

    const editAnnouncement = (data) => {
        handleEditAnnouncementType(data)
        setIsEditAnnType(true)
        setCreateAnnType(true)
    }

    return (
        <>
            <h3 className="color-white">Select Announcement Type</h3>
            <span className="color-gray font-14 mb-4">Choose the type of announcement you want to create</span>

            <div className="announcements mt-4">


                {
                    annTypeLict?.map((item) => {
                        return <div
                            className="announcement-item"
                            onClick={() => { setAnnouncementType(item.announceId); handleAnnouncementTitleId(item.announcementTitleId); setAnnouncementTypeIcon(item.announceIcon); handleAnnTypeClicked(item) }}
                            key={item.announceId}
                            style={{
                                background: `linear-gradient(to right, ${item.colorCode}10 0%, ${item.colorCode}04 100%`,
                                border: announcementType == item.announceId ? `1px solid ${item.colorCode}` : `1px solid ${item.colorCode}30`,
                                // color: announcementType == item.announceId ? `${item.colorCode}99` : ``,
                            }}
                        >
                            <div className='ann-acctions' style={{ width: "200px" }}>
                                <button
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        deleteAnnouncement(item.announceId);
                                    }}
                                    className='ann-del'
                                >
                                    <RiDeleteBinLine />
                                </button>
                                <button
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        editAnnouncement(item);
                                    }}
                                    className='ann-edit'
                                >
                                    <PiPencilSimpleLineBold />
                                </button>
                            </div>

                            <span className="icon"> <img src={item.announceIcon} /></span>
                            <h3>{item.announceTypeName}</h3>
                            <h5
                            // style={{
                            //     color: announcementType == item.announceId ? `${item.colorCode}99` : ``,
                            // }}
                            >{item.announceDesc}</h5>
                        </div>
                    }) || null
                }
                {/* <div
                    className={announcementType == "festival" ? "announcement-item festival active" : "announcement-item festival"} onClick={() => setAnnouncementType("festival")}>
                    <span className="icon"> <img src={"festival"} /></span>
                    <h3>Festival</h3>
                    <h5>Celebrate holidays</h5>
                </div>

                <div className={announcementType == "birthday" ? "announcement-item birthday active" : "announcement-item birthday"} onClick={() => setAnnouncementType("birthday")}>
                    <span className="icon"><img src={"birthday"} /> </span>
                    <h3>Birthday</h3>
                    <h5>Team birthdays</h5>
                </div>
                <div className={announcementType == "anniversary" ? "announcement-item anniversary active" : "announcement-item anniversary"} onClick={() => setAnnouncementType("anniversary")}>
                    <span className="icon"><img src={"aniversary"} /> </span>
                    <h3>Work Anniversary</h3>
                    <h5>Milestone celebrations</h5>
                </div>
                <div className={announcementType == "appreciation" ? "announcement-item appreciation active" : "announcement-item appreciation"} onClick={() => setAnnouncementType("appreciation")}>
                    <span className="icon"><img src={"star"} /> </span>
                    <h3>Employee Appreciation</h3>
                    <h5>Recognition posts</h5>
                </div>

                <div className={announcementType == "onboarding" ? "announcement-item onboarding active" : "announcement-item onboarding"} onClick={() => setAnnouncementType("onboarding")}>
                    <span className="icon"><img src={"onbording"} /> </span>
                    <h3>Onboarding</h3>
                    <h5>Welcome new hires</h5>
                </div>
                <div className={announcementType == "sales" ? "announcement-item sales active" : "announcement-item sales"} onClick={() => setAnnouncementType("sales")}>
                    <span className="icon"><img src={"sales"} /></span>
                    <h3>Sales/Promotion</h3>
                    <h5>Business updates</h5>
                </div>
                <div className={announcementType == "gannouncement" ? "announcement-item gannouncement active" : "announcement-item gannouncement"} onClick={() => setAnnouncementType("gannouncement")}>
                    <span className="icon"><img src={"announce"} /></span>
                    <h3>General Announcement</h3>
                    <h5>Company-wide updates</h5>
                </div>
                <div className={announcementType == "notice" ? "announcement-item notice active" : "announcement-item notice"} onClick={() => setAnnouncementType("notice")}>
                    <span className="icon"><img src={"notice"} /></span>
                    <h3>Urgent Notice</h3>
                    <h5>Important alerts</h5>
                </div> */}
            </div>
        </>
    )
}

export default AnnouncementType